import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ManagementDashboard from "@/pages/ManagementDashboard";
import Assets from "@/pages/Assets";
import AssetDetail from "@/pages/AssetDetail";
import AssetReport from "@/pages/AssetReport";
import AssetTags from "@/pages/AssetTags";
import Maintenance from "@/pages/Maintenance";
import Faults from "@/pages/Faults";
import PatTests from "@/pages/PatTests";
import Users from "@/pages/Users";
import ListReport from "@/pages/ListReport";
import Reports from "@/pages/Reports";
import PatTag from "@/pages/PatTag";
import Dashboard from "@/pages/Dashboard";
import SurveyEditor from "@/pages/SurveyEditor";
import Report from "@/pages/Report";

function App() {
  return (
    <div className="App grain-bg">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/" element={<ManagementDashboard />} />
                <Route path="/assets" element={<Assets />} />
                <Route path="/assets/:id" element={<AssetDetail />} />
                <Route path="/maintenance" element={<Maintenance />} />
                <Route path="/faults" element={<Faults />} />
                <Route path="/pat-tests" element={<PatTests />} />
                <Route path="/users" element={<Users />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/surveys" element={<Dashboard />} />
              </Route>
              <Route path="/survey/:id" element={<SurveyEditor />} />
              <Route path="/survey/:id/report" element={<Report />} />
              <Route path="/assets/tags" element={<AssetTags />} />
              <Route path="/assets/:id/report" element={<AssetReport />} />
              <Route path="/reports/:type" element={<ListReport />} />
              <Route path="/assets/:id/pat-tag" element={<PatTag />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
